import { Routes, RouterModule } from '@angular/router';
import { HisAuthGuard } from 'hisng';
import { JobApplicationPageComponent } from './component/create/jobapplication-page.component';

export const ROUTE_CONFIG: Routes = [
    {
        // Bewerbungserfassungsmaske mit Übersicht und Erfolgsseite
        path: 'create/jobapplication/:advertisementId',
        component: JobApplicationPageComponent,
        canActivate: [HisAuthGuard],
        data: {
            hasAll: ['RIGHT_EVERYONE'],
            modules: ['HISINONEBWM']
        }
    }
];

// eslint-disable-next-line @typescript-eslint/naming-convention
export const JobApplicationRoutesModule = RouterModule.forChild( ROUTE_CONFIG );
